import { render, staticRenderFns } from "./LabelDetailContainer.vue?vue&type=template&id=556f83d5&"
import script from "./LabelDetailContainer.vue?vue&type=script&lang=js&"
export * from "./LabelDetailContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports